export default [{
  path: '/view/emailconfiguration',
  name: 'emailconfiguration',
  component: () => import('@/app/email-configuration/EmailConfiguration'),
  meta: {
  }
}]
